// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.dataCapturePage {
  background-color: #f8f7f3;
  /* These rules is to override the one above it until we have styled components implemented for the related components */
}
.dataCapturePage h1 {
  margin: 30px auto 8px auto;
  font-size: 32px;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  color: #262626;
  letter-spacing: -0.822222px;
}
.dataCapturePage p,
.dataCapturePage li {
  text-align: left;
}
.dataCapturePage p {
  margin-bottom: 0;
}
.dataCapturePage .bold {
  font-weight: normal;
}
.dataCapturePage .k-form-separator {
  margin: 0;
  border: none;
  margin: 0.75rem 0;
}
.dataCapturePage .k-form-field {
  padding: 0;
}
.dataCapturePage .k-form-field .k-input,
.dataCapturePage .k-form-field .label,
.dataCapturePage .k-form-field input,
.dataCapturePage .k-form-field textarea {
  color: #262626;
}
.dataCapturePage .k-form-field .label {
  opacity: 0.65;
}
.dataCapturePage .k-form .error {
  padding: 0 0 0 8px;
}
.dataCapturePage .k-form .dataCapturePageMessage.error {
  padding: 8px;
}
.dataCapturePage .k-form .dataCapturePageMessage.error p {
  vertical-align: unset;
}
.dataCapturePage .globalFooter p {
  text-align: center;
}
.dataCapturePage .bp4-overlay {
  z-index: 102;
  position: absolute;
}
.dataCapturePage #app #bodyContent {
  padding-top: 0.05px;
  padding-bottom: 100px;
}
@media (max-width: 845px) {
  .dataCapturePage .formLayout.k-form fieldset {
    width: 320px;
  }
  .dataCapturePage .flowButtons {
    max-width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/DataCapturePage.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EACC,yBAAA;EAYC,uHAAuH;AACzH;AAdA;EAIE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AAaF;AAvBA;;EAeE,gBAAA;AAYF;AA3BA;EAmBE,gBAAA;AAWF;AA9BA;EAuBE,mBAAA;AAUF;AAjCA;EA2BE,SAAA;EACA,YAAA;EACA,iBAAA;AASF;AAtCA;EAiCE,UAAA;AAQF;AAzCA;;;;EAuCG,cAAA;AAQH;AA/CA;EA2CG,aAAA;AAOH;AAlDA;EAgDE,kBAAA;AAKF;AArDA;EAqDE,YAAA;AAGF;AAxDA;EAwDG,qBAAA;AAGH;AA3DA;EA6DE,kBAAA;AACF;AA9DA;EAiEE,YAAA;EACA,kBAAA;AAAF;AAlEA;EAsEE,mBAAA;EACA,qBAAA;AADF;AAIC;EAAA;IAEE,YAAA;EAFD;EAAD;IAME,gBAAA;EAHD;AACF","sourcesContent":["@import '../../constants.less';\n\n.dataCapturePage {\n\tbackground-color: @fieldBackgroundWhite;\n\n\th1 {\n\t\tmargin: 30px auto 8px auto;\n\t\tfont-size: 32px;\n\t\tfont-weight: bold;\n\t\theight: 40px;\n\t\tline-height: 40px;\n\t\tcolor: @grey26;\n\t\tletter-spacing: -0.822222px;\n\t}\n\n\tp,\n\tli {\n\t\ttext-align: left;\n\t}\n\n\tp {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.bold {\n\t\tfont-weight: normal;\n\t}\n\n\t.k-form-separator {\n\t\tmargin: 0;\n\t\tborder: none;\n\t\tmargin: 0.75rem 0;\n\t}\n\n\t.k-form-field {\n\t\tpadding: 0;\n\n\t\t.k-input,\n\t\t.label,\n\t\tinput,\n\t\ttextarea {\n\t\t\tcolor: @grey26;\n\t\t}\n\n\t\t.label {\n\t\t\topacity: 0.65;\n\t\t}\n\t}\n\n\t.k-form .error {\n\t\tpadding: 0 0 0 8px;\n\t}\n\n\t/* These rules is to override the one above it until we have styled components implemented for the related components */\n\t.k-form .dataCapturePageMessage.error {\n\t\tpadding: 8px;\n\n\t\tp {\n\t\t\tvertical-align: unset;\n\t\t}\n\t}\n\n\t.globalFooter p {\n\t\ttext-align: center;\n\t}\n\n\t.bp4-overlay {\n\t\tz-index: 102;\n\t\tposition: absolute;\n\t}\n\n\t#app #bodyContent {\n\t\tpadding-top: 0.05px;\n\t\tpadding-bottom: 100px;\n\t}\n\n\t@media (max-width: @dataCaptureOneColumnFieldsPageMaxWidth) {\n\t\t.formLayout.k-form fieldset {\n\t\t\twidth: @formFieldsetWidthForMobile;\n\t\t}\n\n\t\t.flowButtons {\n\t\t\tmax-width: @formFieldsetWidthForMobile;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
